import { render, staticRenderFns } from "./EditPatient.vue?vue&type=template&id=07b3f937&scoped=true&"
import script from "./EditPatient.vue?vue&type=script&lang=ts&"
export * from "./EditPatient.vue?vue&type=script&lang=ts&"
import style0 from "./EditPatient.vue?vue&type=style&index=0&id=07b3f937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3f937",
  null
  
)

export default component.exports